export default {
  survey: {
    restartSurvey: 'Inizia un nuovo sondaggio',
    sendingSurvey: 'Invio del tuo sondaggio. Siete pregati di attendere…',
    errorSending: 'Siamo spiacenti, non è stato possibile inviare il sondaggio. Controlla la tua connettività e riprova più tardi.',
    retryBtnText: 'Riprova',
    // TODO: Translate (PWA)
    sending: 'Not Implemented.',
    checkoutError: 'Not Implemented.',
    doneBtnText: 'Not Implemented.',
    uploadImage: 'Not Implemented.',
    submitFeedback: 'Invia il feedback'
  }
};